import { createRef } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import {
  BackToLoginLink,
  Email,
  Form,
  FormError,
  Link,
  OperationButton,
  Rule
} from '@/components/core-v2'
import { EmailField } from '@/components/core-v2/molecules/fields/email'
import { useResetPasswordRequest } from '@/utilities/hooks/useResetPasswordRequest'

import { BaseFormProps } from '../types'
import { COPY } from './constants'
import { ContactUs } from './contact-us'
import classes from './index.module.scss'

export type ResetPasswordRequestFields = EmailField

export const ResetPasswordRequestForm = ({ onSuccess }: BaseFormProps) => {
  const recaptchaRef = createRef()
  const form = useForm<ResetPasswordRequestFields>()

  const { isError, isLoading, submitResetPassword } = useResetPasswordRequest()

  const onSubmit = async ({ email }: ResetPasswordRequestFields) => {
    const response = await submitResetPassword({ email, recaptchaRef })
    const hasError = response.hasOwnProperty('error')

    if (!hasError) {
      onSuccess()
    }
  }

  return (
    <section>
      <FormProvider {...form}>
        <Form
          noValidate
          aria-busy={isLoading}
          name="Reset password form"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <Email isDisabled={isLoading} />
          <FormError className="mt-5" isShowing={isError} title="Error">
            {COPY.error}
          </FormError>
          <OperationButton
            className={classes.button}
            isDisabled={isLoading}
            isLoading={isLoading}
            operationType="progress"
            type="submit"
            width="100%"
          >
            {COPY.resetPassword}
          </OperationButton>
        </Form>
      </FormProvider>

      <BackToLoginLink className="my-12" />

      <Rule className="mb-12" />

      <ContactUs />

      <p className={classes.recaptcha}>
        This site is protected by reCAPTCHA, and the Google{' '}
        <Link to="https://www.google.com/intl/en/policies/privacy/">Privacy Policy</Link> and{' '}
        <Link to="https://www.google.com/intl/en/policies/terms/">Terms of Service</Link> apply.
      </p>
    </section>
  )
}
